import cloneDeep from 'lodash/cloneDeep';
import initialState from '../initialstate';
import Utility from '../../util/utilityfunctions';
import {
	entities,
	ITApproachType,
	dataSortingOrder,
	EngagementCommentStatus,
	formBodyType,
	OperationTypes,
	documentCategoryNames,
	documentTabLayoutTabs,
	viewportBodyTypesList,
	multiOptionBodyTypes
} from '../../util/uiconstants';
import {isApiResponseOk} from '../../util/utils';
import {createUpdatePayloadForRichText} from '../../components/Common/CanvasForm/Bodies/Common/BodyResponseUtility';
import {
	ADD_CUSTOM_BODY,
	CLEAR_FORMBODYDISPLAYDATA,
	CLEAR_PROFILE_DATA,
	CREATE_INDEPENDENCE_FORM,
	CREATE_RELATED_DOCUMENT,
	CREATE_RISK_FACTOR_RELATION,
	CREATE_RISK_FORMBODYOPTION,
	DELETE_DOCUMENT_BY_ID,
	DELETE_FORM_BODY,
	DELETE_RISK_FORMBODYOPTION,
	EDIT_BODY,
	GET_ALL_RELATED_DOCUMENTS_FOR_BODIES,
	GET_BODY_GUIDANCES,
	GET_FORM_BODIES_AFTER_RESPONSE,
	GET_FORM_BODIES_BY_SECTIONID,
	GET_FORM_PROFILE_DATA_BY_ID,
	OVERWRITE_FORM,
	REMOVE_RISK_FACTOR_RELATION,
	SUBMIT_INDEPENDENCE,
	SUBMIT_INDEPENDENCE_ACTION,
	SUBMIT_PROFILE,
	UPDATE_BODY_COMMENT_COUNT_AFTER_CLOSING_COMMENTS,
	UPDATE_BODY_FREE_TEXT,
	UPDATE_BODY_FREE_TEXT_IN_FORM_BODY_DISPLAY_DATA_FOR_UPDATING,
	UPDATE_BODY_ON_CONFLICT,
	UPDATE_BODY_RELATED_COUNT,
	UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS,
	UPDATE_DOCUMENT_COUNT_ON_TEMPORARY_FILE_UPLOAD,
	UPDATE_FORM_BODY_DATA,
	UPDATE_FORM_BODY_DISPLAY_DATA,
	UPDATE_FORM_BODY_DISPLAY_DATA_ONLY,
	UPDATE_FORM_BODY_RELATED_DEFICIENCY,
	UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE,
	UPDATE_FORM_BODY_RESPONSE,
	UPDATE_FORM_BODY_RESPONSE_FOR_UPDATE,
	UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE,
	UPDATE_FORM_PROFILE_RESPONSE,
	UPDATE_FORMBODY_RISKFACTORS,
	UPDATE_RICH_TEXT_BODY,
	UPDATE_RISK_FACTOR_RELATION_DESCRIPTION
} from '../../actions/actiontypes';
import {findRiskFactorFromFormData} from '../../actions/RiskFactor/riskfactoractions';
import {findRiskFromFormData} from '../../actions/Risk/riskactions';

export function formProfileDataReducer(state = initialState.formProfileData, action) {
	switch (action.type) {
		case GET_FORM_PROFILE_DATA_BY_ID: {
			return action.response;
		}
		default:
			return state;
	}
}

export function formBodyDisplayDataForUpdateReducer(state = initialState.formBodyDisplayDataForUpdating, action) {
	switch (action.type) {
		case UPDATE_FORM_BODY_RESPONSE_FOR_UPDATE: {
			if (action.response) {
				return action.response;
			} else {
				return state;
			}
		}
		case UPDATE_BODY_FREE_TEXT_IN_FORM_BODY_DISPLAY_DATA_FOR_UPDATING: {
			const newState = {...state};
			if (newState) {
				if (action.data) {
					newState.id = action.data.id;
					newState.discardChanges = action.data.discardChanges;
					newState.bodyFreeText = action.data.bodyFreeText;
					newState.concurrencyToken = action.data.concurrencyToken;
					newState.bodyTypeId = action.data.bodyTypeId;
				}
			}
			return newState;
		}
	}
	return state;
}

export function formBodyDisplayDataReducer(state = initialState.formBodyDisplayData, action) {
	switch (action.type) {
		case UPDATE_FORM_BODY_RESPONSE: {
			if (action.response.bodyTypeId === formBodyType.TextResponse || action.response.bodyTypeId === formBodyType.InlineRichText) {
				processRichTextBodies(action.response);
			}

			if (action.response.isConflict === true) {
				return action.response;
			}

			const newState = action.response;
			const apiPayload = action.meta?.api?.data;

			if (multiOptionBodyTypes.includes(apiPayload?.bodyTypeId)) {
				// Build a serialized key with bodyOptionIds selected in apiPayload.bodyResponseObject
				const selectedOptionIds = (apiPayload.bodyResponseObject || [])
					.filter((o) => o.isSelected)
					.map((o) => o.bodyOptionId)
					.join('_');

				newState.selectedOptionIds = selectedOptionIds;
			}

			return newState;
		}
		case UPDATE_FORM_BODY_DISPLAY_DATA: {
			if (state.isConflict) {
				const body = action.body;
				const copy = {...state};
				if (body.id === copy.id) {
					copy.bodyFreeText = copy.currentDBBodyFreeText;
					copy.concurrencyToken = body.concurrencyToken;
					copy.comparedText = undefined;
					copy.bodyTypeId = body.bodyTypeId;
					copy.currentBodyFreeText = undefined;
					copy.isConflict = body.isConflict ?? false;
					copy.currentDBBodyFreeText = undefined;
					copy.modifiedDate = undefined;
					copy.modifiedUser = undefined;
				}
				return copy;
			}
			return state;
		}
		case UPDATE_BODY_FREE_TEXT: {
			/*if no conflict update formBodyDisplayData with response, specifically the new concurrencyToken*/
			const newState = {};
			if (newState) {
				if (action.data) {
					newState.id = action.data.id;
					newState.discardChanges = action.data.discardChanges;
					newState.bodyFreeText = action.data.bodyFreeText;
					newState.concurrencyToken = action.data.concurrencyToken;
					newState.bodyTypeId = action.data.bodyTypeId;
					newState.isConflict = false;
				}
			}
			return newState;
		}
		case UPDATE_BODY_ON_CONFLICT: {
			const newState = {...state};
			if (action.data) {
				if (newState) {
					newState.bodyTypeId = action.data.conflictResponse.bodyTypeId;
					newState.comparedText = action.data.conflictResponse.comparedText;
					newState.concurrencyToken = action.data.conflictResponse.concurrencyToken;
					newState.currentBodyFreeText = action.data.conflictResponse.currentBodyFreeText;
					newState.currentDBBodyFreeText = action.data.conflictResponse.currentDBBodyFreeText;
					newState.isConflict = action.data.conflictResponse.isConflict;
					newState.modifiedDate = action.data.conflictResponse.modifiedDate;
					newState.modifiedUser = action.data.conflictResponse.modifiedUser;
					newState.id = action.data.conflictResponse.id;
					newState.timestamp = Date.now();
				}
			}
			return newState;
		}
		case CLEAR_FORMBODYDISPLAYDATA: {
			return {};
		}
		case UPDATE_FORM_BODY_DISPLAY_DATA_ONLY: {
			if (action.response) {
				// Do NOT spread ...state here. Spreading state would carry over bodyTypeId,
				// bodyFreeText, concurrencyToken etc. from a previous regular save response,
				// which would then corrupt unrelated bodies in updateBodyDisplayAndConcurrencyToken
				// (see containerFunctions.js thisBody logic). Only store what is needed for
				// display-only updates: the triggering bodyId and the display details.
				return {id: action.bodyId, bodyIsDisplayDetails: action.response};
			}
			return state;
		}
		default:
			return state;
	}
}

function processRichTextBodies(response) {
	/!*need to save response concurrency token for later saves*!/;
	const newPayload = createUpdatePayloadForRichText(
		response.id,
		response.bodyTypeId,
		response.isConflict ? response.currentBodyFreeText : response.bodyFreeText,
		response.concurrencyToken
	);
	const key = `ares_engagement_${response.engagementId}_document_${response.documentId}_${response.id}`;
	sessionStorage.setItem(key, JSON.stringify(newPayload));
}

export function formBodyDisplayDataNoStoreUpdateReducer(state = initialState.formBodyDisplayDataNoStoreUpdate, action) {
	switch (action.type) {
		case UPDATE_FORM_BODY_RESPONSE_NO_STORE_UPDATE: {
			/*This is just used to make an api call. We dont want any store to change*/
			return state;
		}
		default:
			return state;
	}
}

export function formProfileUpdateDataReducer(state = initialState.formProfileUpdateData, action) {
	switch (action.type) {
		case UPDATE_FORM_PROFILE_RESPONSE: {
			return action.response;
		}
		default:
			return state;
	}
}

export function formOverwriteDataReducer(state = initialState.formOverwriteData, action) {
	switch (action.type) {
		case OVERWRITE_FORM: {
			return action.response;
		}
		default:
			return state;
	}
}

export function formBodyDataReducer(state = initialState.formBodyData, action) {
	switch (action.type) {
		case CREATE_RELATED_DOCUMENT: {
			if (action.skipDocumentCountUpdate) {
				return state;
			}
			const formBodyData = cloneDeep(state);
			const entityUId = action.meta.entityUId || +action.response.entityUId;
			const tabname = action.meta.tabname || action.tabname;
			const sectionId = +(action.meta.sectionId || action.sectionId);
			const formDataIndex = formBodyData.findIndex((f) => f.sectionId === sectionId);
			if (
				formDataIndex > -1 &&
				tabname &&
				entityUId &&
				formBodyData &&
				formBodyData[formDataIndex] &&
				formBodyData[formDataIndex].bodies &&
				action.response !== ''
			) {
				formBodyData[formDataIndex].bodies.map((mainBody) => {
					if (mainBody.id === entityUId) {
						switch (tabname) {
							case documentTabLayoutTabs.evidenceName:
								mainBody.evidenceDocumentReferenceCount = mainBody.evidenceDocumentReferenceCount + 1;
								break;
							case documentTabLayoutTabs.priorPeriodName:
								mainBody.priorPeriodDocumentReferenceCount = mainBody.priorPeriodDocumentReferenceCount + 1;
								break;
						}
					}
				});
				return formBodyData;
			} else return state;
		}
		case DELETE_DOCUMENT_BY_ID: {
			const formBodyData = cloneDeep(state);
			const sectionId = action.meta.sectionId;
			const formDataIndex = formBodyData.findIndex((f) => f.sectionId === sectionId);
			if (
				formDataIndex > -1 &&
				sectionId &&
				action.meta.tabname &&
				action.entityUId &&
				formBodyData &&
				formBodyData[formDataIndex] &&
				formBodyData[formDataIndex].bodies
			) {
				formBodyData[formDataIndex].bodies.map((mainBody) => {
					if (mainBody.id === action.entityUId) {
						switch (action.meta.tabname) {
							case documentTabLayoutTabs.evidenceName:
								mainBody.evidenceDocumentReferenceCount = mainBody.evidenceDocumentReferenceCount - 1;
								break;
							case documentTabLayoutTabs.priorPeriodName:
								mainBody.priorPeriodDocumentReferenceCount = mainBody.priorPeriodDocumentReferenceCount - 1;
								break;
							case documentTabLayoutTabs.temporaryName:
								mainBody.temporaryDocumentReferenceCount = mainBody.temporaryDocumentReferenceCount - 1;
								break;
						}
					}
				});
				return formBodyData;
			} else return state;
		}
		case GET_ALL_RELATED_DOCUMENTS_FOR_BODIES: {
			const formBodyData = cloneDeep(state);

			if (action.meta.entityUId && formBodyData && formBodyData.length > 0) {
				return formBodyData.map((formBodyItem) => {
					return {
						...formBodyItem,
						bodies: formBodyItem.bodies.map((mainBody) => {
							if (mainBody.id === action.meta.entityUId) {
								switch (action.meta.documentCategoryName) {
									case documentCategoryNames.evidence:
									case documentCategoryNames.canvasFormBodyEvidence:
										return {
											...mainBody,
											evidenceDocumentReferenceCount: action.response.totalEntityCount
										};
									case documentCategoryNames.priorPeriod:
										return {
											...mainBody,
											priorPeriodDocumentReferenceCount: action.response.totalEntityCount
										};
									case documentCategoryNames.temporary:
										return {
											...mainBody,
											temporaryDocumentReferenceCount: action.response.totalEntityCount
										};
									case documentCategoryNames.external:
										return {
											...mainBody,
											externalDocumentReferenceCount: action.response.totalEntityCount
										};
									default:
										return mainBody;
								}
							}

							return mainBody;
						})
					};
				});
			}

			return state;
		}
		case GET_FORM_BODIES_BY_SECTIONID: {
			if (!isApiResponseOk(action)) {
				return state;
			}

			const stateCopy = JSON.parse(JSON.stringify(state));
			if (action.response && action.response.length > 0) {
				const responseCopy = JSON.parse(JSON.stringify(action.response));
				let responseCopySorted = JSON.parse(JSON.stringify(action.response));
				/*sort and prep bodies for display*/
				if (responseCopy.length > 0) {
					responseCopy.sort(Utility.sortByMultipleKey([dataSortingOrder.knowledgeDisplayOrder, dataSortingOrder.name, dataSortingOrder.customLabel]));
					responseCopySorted = responseCopy.map((body) => {
						return {
							...body,
							bodyIncompleteResponseCount: 0,
							bodyUnresolvedCommentsCount: 0
						};
					});
				}
				const indexOfBodies = stateCopy.findIndex((body) => {
					return responseCopySorted[0].sectionId === body.sectionId;
				});
				if (indexOfBodies >= 0) {
					/*update the bodies for the sectionId*/
					stateCopy.splice(indexOfBodies, 1, {
						sectionId: responseCopySorted[0].sectionId,
						bodies: responseCopySorted
					});
				} else {
					/*add the bodies and the sectionId to the store*/
					stateCopy.push({
						sectionId: responseCopySorted[0].sectionId,
						bodies: responseCopySorted
					});
				}
				return stateCopy;
			} else {
				const requestUrl = action.meta.api.url;
				const sectionId = Number(requestUrl.split('/')[11]);
				if (stateCopy.findIndex((d) => d.sectionId === sectionId) < 0) {
					stateCopy.push({
						sectionId: sectionId,
						bodies: []
					});
				} else {
					const index = stateCopy.findIndex((d) => d.sectionId === sectionId);
					stateCopy[index].bodies = [];
				}
				return stateCopy;
			}
		}
		case ADD_CUSTOM_BODY: {
			if (action.response) {
				const newState = JSON.parse(JSON.stringify(state));
				if (state.length === 0) {
					/*add the bodies and the sectionId to the store*/
					newState.push({
						sectionId: action.response.sectionId,
						bodies: []
					});
				}
				if (newState.findIndex((d) => d.sectionId === action.response.sectionId) > -1) {
					newState
						.find((d) => d.sectionId === action.response.sectionId)
						.bodies.push({
							bodyTypeId: action.response.bodyTypeId,
							id: action.response.id,
							isCustom: true,
							knowledgeDisplayOrder: null,
							isDisplayed: action.response.isDisplayed,
							bodyFreeText: action.response.bodyFreeText,
							name: action.response.name,
							concurrencyToken: action.response.concurrencyToken
						});
					newState
						.find((d) => d.sectionId === action.response.sectionId)
						.bodies.sort(Utility.sortByMultipleKey([dataSortingOrder.knowledgeDisplayOrder, dataSortingOrder.name, dataSortingOrder.customLabel]));
				}

				return newState;
			}
			return state;
		}
		case GET_FORM_BODIES_AFTER_RESPONSE: {
			if (action.response && action.response.length > 0) {
				const sectionIndex = state.findIndex((a) => a.sectionId === action.sectionId);
				if (sectionIndex === -1) {
					// Add new section to state
					return [
						...state,
						{
							sectionId: action.sectionId,
							bodies: action.response.map((r) => ({
								...r,
								bodyRelatedObjects: r.bodyRelatedObjects || []
							}))
						}
					];
				} else {
					// Update existing section in state
					return [
						...state.slice(0, sectionIndex),
						{
							...state[sectionIndex],
							bodies: state[sectionIndex].bodies.map((body) => {
								const responseBody = action.response.find((r) => r.id === body.id) || {};
								if (viewportBodyTypesList.includes(responseBody.bodyTypeId) && responseBody.alternateFormBodyId === null) {
									responseBody.isDisplayed = false;
								}
								return {
									...body,
									...responseBody,
									bodyRelatedObjects: body.bodyRelatedObjects
								};
							})
						},
						...state.slice(sectionIndex + 1)
					];
				}
			} else {
				return state;
			}
		}
		case UPDATE_FORM_BODY_RELATEOBJECTS_AFTER_RESPONSE: {
			const _state = cloneDeep(state);
			if (action.response) {
				let body = undefined;
				_state.every((fbd) => {
					fbd.bodies.every((fbdbody) => {
						if (Number(fbdbody.id) === Number(action.response.bodyId)) {
							body = fbdbody;
							return false;
						}
						return true;
					});
					if (body) {
						return false;
					}
					return true;
				});

				if (body && action.response?.entityId === entities.ItRisk && action.response.hasNoITGC) {
					const mapItProcess = (itProcess) => {
						const children = itProcess.children.filter((itRisk) => Number(itRisk.entityUId) !== Number(action.response.entityUId));

						if (children.length === 0) {
							return [];
						}

						return [
							{
								...itProcess,
								children
							}
						];
					};

					body.bodyRelatedObjects = body.bodyRelatedObjects.flatMap((itgc) => {
						if (itgc.entityId === entities.ItControl && itgc.itApproachTypeId === ITApproachType.Controls) {
							const children = itgc.children.flatMap((itProcess) => mapItProcess(itProcess));

							return [
								{
									...itgc,
									children
								}
							];
						} else {
							return [{...itgc}];
						}
					});

					const fbro = findBodyRelatedObject(body.bodyRelatedObjects, action.response.entityId, action.response.entityUId);

					fbro.forEach((data) => {
						data.hasNoITGC = action.response.hasNoITGC;
						data.entityName = action.response.entityName;
						data.bodyId = action.response.bodyId;
					});

					return _state;
				}

				if (body) {
					let fbro;
					if (action.operationType === OperationTypes.relate || action.operationType === OperationTypes.unrelate) {
						// 1. Find all parent entity occurrencies:
						fbro = findBodyRelatedObject(body.bodyRelatedObjects, action.response.parentEntityId, action.response.parentEntityUId);

						// This property is a string in the store
						const entityUId = action.response.entityUId.toString();

						if (action.operationType === OperationTypes.unrelate) {
							// 2. Remove current entity from its parent's children collection
							fbro.forEach((parent) => {
								if (parent.children) {
									parent.children = parent.children.filter((child) => child.entityId === action.response.entityId && child.entityUId !== entityUId);
								}
							});
						} else {
							// 2. Add current entity to its parent's children collection
							fbro.forEach((parent) => {
								if (parent.children && !parent.children.find((child) => child.entityId === action.response.entityId && child.entityUId === entityUId)) {
									parent.children.push({...action.response, entityUId: entityUId});
								}
							});
						}
					} else if (action.operationType === OperationTypes.update) {
						// Default operation type
						fbro = findBodyRelatedObject(body.bodyRelatedObjects, action.response.entityId, action.response.entityUId);
						fbro.forEach((data) => {
							data.entityName = action.response.entityName;
							data.strategyTypeId = action.response.strategyTypeId;
							data.riskTypeId = action.response.riskTypeId;
							data.hasNoITGC = action.response.hasNoITGC;
							data.controlFrequencyTypeId = action.response.controlFrequencyTypeId;
							data.controlTypeId = action.response.controlTypeId;
							data.iTApplications = action.response.iTApplications;
							data.designEffectiveness = action.response.designEffectiveness;
							data.isEffective = action.response.isEffective;
							data.hasControlTesting = action.response.hasControlTesting;
							data.isLowerRisk = action.response.isLowerRisk;
							data.controlFrequencyTypeId = action.response.controlFrequencyTypeId;
							data.itApproachTypeId = action.response.itApproachTypeId;
							data.isEffective = action.response.isEffective;
							data.hasitcontroltesting = action.response.hasControlTesting;
						});
					}
					// TODO Implement logic for remaining operation types (create / delete)
				}
				return _state;
			} else {
				return state;
			}
		}
		case DELETE_FORM_BODY: {
			const bodySectionState = JSON.parse(JSON.stringify(state));
			if (action.bodyId && !action.error) {
				bodySectionState.forEach((bodySectionDetails) => {
					bodySectionDetails.bodies.some((b, i, bb) => {
						if (b.id === action.bodyId) {
							bb.splice(i, 1);
							return true;
						}
					});
				});
			}
			return bodySectionState;
		}
		case EDIT_BODY:
			if (action.response) {
				const newSectionState = JSON.parse(JSON.stringify(state));
				let bodyInEdit = {};
				newSectionState.forEach((sectionDetails) => {
					const indexForBody = sectionDetails.bodies.findIndex((d) => d.id === action.response.id);

					if (indexForBody > -1) {
						bodyInEdit = sectionDetails.bodies[indexForBody];
						newSectionState.find((t) => t.sectionId === sectionDetails.sectionId).bodies = newSectionState
							.find((t) => t.sectionId === sectionDetails.sectionId)
							.bodies.filter((d) => d.id !== action.response.id);
					}
				});
				if (newSectionState.some((d) => d.sectionId === action.response.sectionId)) {
					newSectionState
						.find((d) => d.sectionId === action.response.sectionId)
						.bodies.push({
							...bodyInEdit,
							bodyTypeId: action.response.bodyTypeId,
							id: action.response.id,
							isCustom: true,
							knowledgeDisplayOrder: null,
							isDisplayed: action.response.isDisplayed,
							bodyFreeText: action.response.bodyFreeText,
							name: action.response.name
						});
					newSectionState
						.find((d) => d.sectionId === action.response.sectionId)
						.bodies.sort(Utility.sortByMultipleKey([dataSortingOrder.knowledgeDisplayOrder, dataSortingOrder.name, dataSortingOrder.customLabel]));
				}
				return newSectionState;
			} else {
				return state;
			}
		case UPDATE_COMMENT_COUNT_AFTER_CLOSING_COMMENTS:
		case UPDATE_BODY_COMMENT_COUNT_AFTER_CLOSING_COMMENTS:
			{
				if (action.bodyIds) {
					const _state = cloneDeep(state);
					action.bodyIds.map((bodyId) => {
						const body = _state[0].bodies.filter((b) => {
							return b.id === bodyId;
						});
						if (body && body.length > 0 && body[0].engagementComments.length > 0) {
							body[0].engagementComments.map((ec) => {
								ec.engagementCommentStatusId = EngagementCommentStatus.closed;
							});
						}
					});
					return _state;
				}
			}
			break;
		case UPDATE_BODY_RELATED_COUNT:
			{
				if (action.data.id > 0) {
					let relatedDocBodyState = cloneDeep(state);

					relatedDocBodyState = relatedDocBodyState.map((doc) => {
						return {
							...doc,
							bodies: [
								...doc.bodies.map((body) => ({
									...body,
									evidenceDocumentReferenceCount: body.id === action.data.id ? action.data.relatedDocCount : body.evidenceDocumentReferenceCount
								}))
							]
						};
					});

					return relatedDocBodyState;
				}
			}
			break;
		case UPDATE_RISK_FACTOR_RELATION_DESCRIPTION: {
			if (!action.error) {
				const {sectionId, bodyId, riskFactorId, optionId} = action;

				const newState = cloneDeep(state);
				const sectionModel = newState.find((s) => s.sectionId === sectionId);

				if (sectionModel) {
					const bodyModel = sectionModel.bodies.find((b) => b.id === bodyId);
					const optionModel = bodyModel?.optionsAndResponses.find((o) => o.bodyOptionId === optionId);
					const riskFactor = optionModel?.riskFactorList.find((rf) => rf.id === riskFactorId);

					if (riskFactor) {
						riskFactor.customDescription = action.response.customDescription;
					}
				}
				return newState;
			}
			return state;
		}
		case CREATE_RISK_FACTOR_RELATION: {
			if (!action.error) {
				const {sectionId, bodyId, riskFactorId, formBodyOptionId} = action;

				const newState = cloneDeep(state);

				const riskFactor = findRiskFactorFromFormData(newState, bodyId, formBodyOptionId, riskFactorId, sectionId);

				if (riskFactor) {
					riskFactor.customDescription = action.response.customDescription;
					riskFactor.riskFactorRelationId = action.response.id;
				}

				return newState;
			}
			return state;
		}
		case REMOVE_RISK_FACTOR_RELATION: {
			if (!action.error) {
				const {sectionId, bodyId, riskFactorId, formBodyOptionId} = action;

				const newState = cloneDeep(state);

				const riskFactor = findRiskFactorFromFormData(newState, bodyId, formBodyOptionId, riskFactorId, sectionId);

				if (riskFactor) {
					riskFactor.customDescription = undefined;
					riskFactor.riskFactorRelationId = undefined;
				}

				return newState;
			}
			return state;
		}
		case CREATE_RISK_FORMBODYOPTION: {
			if (!action.error && action.response) {
				const {sectionId, bodyId, risk, formBodyOptionId} = action;

				const newState = cloneDeep(state);

				const riskList = findRiskFromFormData(newState, bodyId, formBodyOptionId, risk.id, sectionId);

				if (riskList) {
					if (!riskList.find((x) => x.riskId === action.response.riskId)) {
						riskList.push({
							formBodyOptionId: action.response.formBodyOptionId,
							riskId: action.response.riskId,
							riskName: risk.riskName,
							riskTypeId: risk.riskTypeId,
							isHigherRisk: risk.isHigherRisk,
							riskIsHigherRisk: risk.riskIsHigherRisk,
							riskSubTypeId: risk.riskSubTypeId
						});
					}
				}

				return newState;
			}
			return state;
		}
		case DELETE_RISK_FORMBODYOPTION: {
			if (!action.error) {
				const newState = cloneDeep(state);

				const riskList = findRiskFromFormData(newState, action.bodyId, action.formBodyOptionId, action.riskId, action.sectionId);

				if (riskList) {
					riskList?.some((b, i, bb) => {
						if (b.riskId === action.riskId) {
							bb.splice(i, 1);
							return true;
						}
					});
				}

				return newState;
			}
			return state;
		}
		case UPDATE_FORM_BODY_DATA: {
			return action.body;
		}
		case UPDATE_RICH_TEXT_BODY: {
			const newState = cloneDeep(state);
			if (newState && newState.length >= 0) {
				const updateSection = newState.find((section) => {
					return section.bodies.find((b) => b.id === action.data.id);
				});
				if (updateSection && updateSection.bodies && updateSection.bodies.length > 0) {
					const updateBody = updateSection.bodies.find((b) => b.id === action.data.id);
					if (updateBody) {
						updateBody.concurrencyToken = action.data.concurrencyToken;
						updateBody.bodyFreeText = action.data.bodyFreeText;
						updateBody.isConflict = action.data.isConflict;
					}
					return newState;
				}
			}
			return state;
		}
		case UPDATE_FORMBODY_RISKFACTORS: {
			const newState = cloneDeep(state);
			if (action.bodyId > 0) {
				const body = newState[0].bodies.find((b) => {
					return Number(b.id) === Number(action.bodyId);
				});
				if (body) {
					const riskFactors = body.optionsAndResponses[0].riskFactorList;

					const found = riskFactors.find((riskfactor) => {
						return riskfactor.id === action.riskId;
					});

					if (found) {
						found.customDescription = action.riskCustomDescription;
					}
				}
			}
			return newState;
		}
		case UPDATE_DOCUMENT_COUNT_ON_TEMPORARY_FILE_UPLOAD: {
			const formBodyData = cloneDeep(state);
			const entityUId = action.entityUid;
			const tabname = action.tabname;
			const sectionId = action.sectionId;
			const formDataIndex = formBodyData.findIndex((f) => f.sectionId === sectionId);
			if (
				formDataIndex > -1 &&
				tabname &&
				entityUId &&
				formBodyData &&
				formBodyData[formDataIndex] &&
				formBodyData[formDataIndex].bodies &&
				action.response !== ''
			) {
				formBodyData[formDataIndex].bodies.map((mainBody) => {
					if (mainBody.id === entityUId) {
						switch (tabname) {
							case documentTabLayoutTabs.temporaryName:
								mainBody.temporaryDocumentReferenceCount = mainBody.temporaryDocumentReferenceCount + 1;
								break;
						}
					}
				});
				return formBodyData;
			} else return state;
		}
		case GET_BODY_GUIDANCES: {
			const sectionId = Number(action.sectionId);

			const bodyId = Number(action.bodyId);

			if (sectionId && bodyId && Array.isArray(action.response)) {
				const cloned = cloneDeep(state);

				const section = cloned.find((section) => section.sectionId === sectionId);

				if (section) {
					const body = section.bodies.find((b) => {
						return b.id === action.bodyId;
					});

					if (body && Array.isArray(action.response)) {
						body.guidanceDocuments = action.response;
						body.guidanceDocumentsReferenceCount = action.response.length;

						return cloned;
					}
				}
			}

			return state;
		}
		case UPDATE_FORM_BODY_RELATED_DEFICIENCY: {
			const {sectionId, bodyId, bodyOptionId, deficiency, isAdd} = action;
			const newState = cloneDeep(state);
			const section = newState.find((s) => s.sectionId === sectionId);
			if (section) {
				const body = section.bodies.find((b) => b.id === bodyId);
				if (body) {
					const option = body.optionsAndResponses?.find((o) => o.bodyOptionId === bodyOptionId);
					if (option) {
						if (!option.relatedDeficiency) {
							option.relatedDeficiency = [];
						}
						if (isAdd) {
							const exists = option.relatedDeficiency.some((d) => (d.deficiencyId || d.id) === (deficiency.deficiencyId || deficiency.id));
							if (!exists) {
								option.relatedDeficiency.push(deficiency);
							}
						} else {
							option.relatedDeficiency = option.relatedDeficiency.filter((d) => (d.deficiencyId || d.id) !== (deficiency.deficiencyId || deficiency.id));
						}
						return newState;
					}
				}
			}
			return state;
		}
		default:
			return state;
	}
}

export function formatFormDataForRail(formData) {
	const railData = [];
	if (formData && formData.headers && formData.headers.length > 0) {
		formData?.headers.forEach((element) => {
			const secondLevel = element.sections;
			if (secondLevel) {
				secondLevel.sort(Utility.sortByMultipleKey([dataSortingOrder.knowledgeDisplayOrder, dataSortingOrder.name, dataSortingOrder.customLabel]));
			}
			const firstLevel = JSON.parse(JSON.stringify(element));
			if (firstLevel) {
				firstLevel.secondLevel = secondLevel;

				delete firstLevel.sections;
				railData.push(firstLevel);
			}
		});
	}
	return railData;
}

export function findBodyRelatedObject(fbro, entityId, entityUId) {
	const foundFbro = [];

	function recursivelyFindRelatedObjectToUpdate(fbro, entityId, entityUId) {
		for (let i = 0; i < fbro.length; i++) {
			if (fbro[i].entityId === entityId && Number(fbro[i].entityUId) === Number(entityUId)) {
				foundFbro.push(fbro[i]);
			} else {
				if (fbro[i].children && fbro[i].children.length > 0) {
					recursivelyFindRelatedObjectToUpdate(fbro[i].children, entityId, entityUId);
				}
			}
		}
	}

	recursivelyFindRelatedObjectToUpdate(fbro, entityId, entityUId);
	return foundFbro;
}

export function SubmitIndependenceDataReducer(state = initialState.engagementUserForIndependence, action) {
	switch (action.type) {
		case SUBMIT_INDEPENDENCE: {
			return action.response;
		}
		default:
			return state;
	}
}

export function SubmitProfileDataReducer(state = initialState.submitProfileDetails, action) {
	switch (action.type) {
		case SUBMIT_PROFILE: {
			if (action.response && !action.error) {
				return action.response;
			} else if (action.error) {
				return action.error;
			}
			return state;
		}
		case CLEAR_PROFILE_DATA: {
			return {};
		}
		default:
			return state;
	}
}

export function SubmitIndependenceActionReducer(state = initialState.independenceActionEngagementUser, action) {
	switch (action.type) {
		case SUBMIT_INDEPENDENCE_ACTION: {
			return action.response;
		}
		default:
			return state;
	}
}

export function IndividualIndependenceDocumentReducer(state = initialState.independenceIndividualDocumentId, action) {
	switch (action.type) {
		case CREATE_INDEPENDENCE_FORM: {
			return action.response;
		}
		default:
			return state;
	}
}
